import { render } from "./Networking.vue?vue&type=template&id=ed48b0bc&ts=true"
import script from "./Networking.vue?vue&type=script&lang=ts"
export * from "./Networking.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__